<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold">{{$t('small_technical_grants_assessments_ev.budget__section_1')}}</h4>
            <h5 class="card-title font-weight-bold">{{$t('small_technical_grants_assessments_ev.budget__section_1_sub')}}</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_1_1')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.proposal_number"
                                 value="true"
                                 v-model="EvaluationForm.model.proposal_number"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.proposal_number"
                                 value="false"
                                 v-model="EvaluationForm.model.proposal_number"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                        {{$t('small_technical_grants_assessments_ev.budget__section_1_2')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.period_implementation"
                                 value="true"
                                 v-model="EvaluationForm.model.period_implementation"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.period_implementation"
                                 value="false"
                                 v-model="EvaluationForm.model.period_implementation"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_1_3')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.categories_follow_sco"
                                 value="true"
                                 v-model="EvaluationForm.model.categories_follow_sco"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.categories_follow_sco"
                                 value="false"
                                 v-model="EvaluationForm.model.categories_follow_sco"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_1_4')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.category_five_follow_real_costs_option"
                                 value="true"
                                 v-model="EvaluationForm.model.category_five_follow_real_costs_option"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.category_five_follow_real_costs_option"
                                 value="false"
                                 v-model="EvaluationForm.model.category_five_follow_real_costs_option"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                 
                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_missing_doc')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_missing_doc" :comments="EvaluationForm.model.comments_budget_missing_doc"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('small_technical_grants_assessments_ev.budget__section_2')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_2_1')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_one"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_one"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_one"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_one"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_2_2')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_two"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_two"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_two"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_two"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_2_3')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_three"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_three"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_three"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_three"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_2_4')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_four"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_four"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_four"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_four"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_mathematical" :comments="EvaluationForm.model.comments_budget_mathematical"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('small_technical_grants_assessments_ev.budget__section_3')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_3_1')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.costs_aligned"
                                 value="true"
                                 v-model="EvaluationForm.model.costs_aligned"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.costs_aligned"
                                 value="false"
                                 v-model="EvaluationForm.model.costs_aligned"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_3_2')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.clearance_ineligible"
                                 value="true"
                                 v-model="EvaluationForm.model.clearance_ineligible"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.clearance_ineligible"
                                 value="false"
                                 v-model="EvaluationForm.model.clearance_ineligible"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_3_3')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.cost_categories"
                                 value="true"
                                 v-model="EvaluationForm.model.cost_categories"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.cost_categories"
                                 value="false"
                                 v-model="EvaluationForm.model.cost_categories"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_3_4')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.diferent_partners"
                                 value="true"
                                 v-model="EvaluationForm.model.diferent_partners"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.diferent_partners"
                                 value="false"
                                 v-model="EvaluationForm.model.diferent_partners"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_3_5')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.clearly_desc_cost"
                                 value="true"
                                 v-model="EvaluationForm.model.clearly_desc_cost"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.clearly_desc_cost"
                                 value="false"
                                 v-model="EvaluationForm.model.clearly_desc_cost"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_eligibility" :comments="EvaluationForm.model.comments_budget_eligibility"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('small_technical_grants_assessments_ev.budget__section_4')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_4_1')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_one"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_one"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_one"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_one"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_4_2')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_two"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_two"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_two"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_two"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_assessments_ev.budget__section_4_3')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_three"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_three"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_three"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_three"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_completness" :comments="EvaluationForm.model.comments_budget_completness"></comment-box>
            </div>
          </div>
        </div>


      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      ApplicationInfo,
      CommentBox
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style lang="scss" scoped>
.pt-5.pb-5 .col-lg-6
{
  white-space: nowrap;
}
</style>
